<template>
  <v-data-table
    :headers="headers"
    :items="data"
    :items-per-page="50"
    class="elevation-1"
  >
   <template v-slot:item.is_active="{ item }">
     <v-btn color="secondary" v-if="!item.is_active" @click="setActive(item._id, true)" icon>
        <v-icon>mdi-eye-off</v-icon>
      </v-btn>
      <v-btn v-else color="warning" @click="setActive(item._id, false)" icon>
        <v-icon>mdi-eye</v-icon>
      </v-btn>
    </template>
    <template v-slot:item.position="{ item }">
      {{ item.position }}
    </template>
     <template v-slot:item.status="{ item }">
      {{ item.status ? statuses.find(el => el.value == item.status).name : '' }}
    </template>
    <template v-slot:item.createdAt="{ item }">
      {{ $formatDate(item.createdAt) }}
    </template>
    <template v-slot:item.actions="{ item }">
      <v-btn color="error" icon @click="remove(item)">
        <v-icon
          color="error"
          small
        >
          mdi-delete
        </v-icon>
      </v-btn>
      <v-btn color="accent" icon @click="edit(item)">
        <v-icon
          color="accent"
          small
        >
          mdi-arrow-right
        </v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      headers: [
        { text: 'Active', value: 'is_active' },
        { text: 'Position', value: 'position' },
        { text: 'Status', value: 'status' },
        { text: 'Added', value: 'createdAt' },
        { text: 'Actions', value: 'actions' },
      ],
      statuses: [
        {
          name: 'Searching for developer', 
          value: 'searching'
        },
        {
          name: 'Waiting for offers response',
          value: 'waiting_offers_response'
        },
        {
          name: 'Preparing to interview',
          value: 'preparing_to_interview'
        },
        {
          name: 'Waiting for interview response',
          value: 'waiting_interview_response'
        },
        {
          name: 'Success',
          value: 'success'
        },
        {
          name: 'Holding',
          value: 'holding'
        },
        {
          name: 'Closed',
          value: 'closed'
        }],
    }
  },
  methods: {

    remove(item) {
      this.loading = true;
      return this.$store.dispatch('jobs/remove', item)
        .finally(() => {
          this.loading = false;
        })
    },
    
    edit(item) {
      this.$store.commit('jobs/setForEdit', item)
      this.$store.commit('jobs/openModal')
    },

    setActive(id, is_active) {
      this.$store.dispatch('jobs/setActiveById', { id, is_active })
    },

  },
  computed: {
    ...mapGetters({
      data: 'jobs/data',
    }),
  }
}
</script>

<style lang="scss" scoped>

</style>>